import { AsyncPipe, NgClass, NgStyle, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject, combineLatest } from 'rxjs';

import { IconComponent } from '@shared/components/icon/icon.component';
import { MoneyPipe } from '@shared/pipes/money.pipe';
import { Currency } from '@shared/services/gql.service';
import { OrganizationQuery } from '@shared/store/organization/organization.query';

import { ForecastQuery } from '../../state/forecast/forecast.query';
import { ForecastService } from '../../state/forecast/forecast.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, NgStyle, NgClass, IconComponent, MoneyPipe, AsyncPipe],
  selector: 'aux-forecast-analytics-section',
  templateUrl: './forecast-analytics-section.component.html',
})
export class ForecastAnalyticsSectionComponent implements OnInit {
  forecastQuery = inject(ForecastQuery);

  private readonly destroyRef = inject(DestroyRef);
  private forecastService = inject(ForecastService);
  private organizationQuery = inject(OrganizationQuery);

  analyticsSectionLoading$ = new BehaviorSubject(false);
  orgCurrency = Currency.USD;

  ngOnInit(): void {
    this.initAnalyticsSection();
  }

  constructor() {
    this.orgCurrency = this.organizationQuery.getActive()?.currency || Currency.USD;
  }

  private initAnalyticsSection(): void {
    this.analyticsSectionLoading$.next(true);
    combineLatest([
      this.forecastService.getActivitiesByDriver(),
      this.forecastService.getUnforecastedCosts(),
    ])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.analyticsSectionLoading$.next(false));
  }
}
